
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandU as ObiOwnShipNoCommandUElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-u.js';
 
 
 

 
 export const ObiOwnShipNoCommandU = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-u',
   elementClass: ObiOwnShipNoCommandUElement,
   events: {
     
   }
  });
 
 